export default class reportFilter {
	constructor(scrollList, filterForm) {
		this.self = this;
		this._init(scrollList, filterForm, this);
	}

	getYearsToHide(yearsValue, item, dataItemsToHide) {
		if (yearsValue && yearsValue !== '') {
			let year = item.getAttribute('data-year');
			if (yearsValue !== year.toString()) {
				let id = item.getAttribute('data-id-report');
				dataItemsToHide.push(id);
			}
		}
	}

	_init(scrollList, filterForm, classElement) {
		filterForm.addEventListener('change', function() {
			let dataItemsToHide = [];
			//Get chosen year

			let yearsDropdown = document.querySelector('#years-report');
			let yearsValue = yearsDropdown.innerHTML;

			if (yearsValue === 'All years') {
				yearsValue = '';
			}

			//add the ids that should be shown to a list
			for (var i = 0; i < scrollList.length; i++) {
				var item = scrollList[i];
				classElement.getYearsToHide(yearsValue, item, dataItemsToHide);
			}

			//Loop through the list and set display none on the ids thats not in the list
			for (let index = 0; index < scrollList.length; index++) {
				let itemToShow = scrollList[index];
				if (
					dataItemsToHide.indexOf(itemToShow.getAttribute('data-id-report')) >
					-1
				) {
					itemToShow.style.display = 'none';
				} else {
					itemToShow.style.display = '';
				}
			}
		});
	}
}
